import React from 'react';
import styled from 'styled-components';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import useSocialmedia from 'gatsby-theme-core/src/hooks/use-socialmedia';
import useCompany from 'gatsby-theme-core/src/hooks/use-company';
import YouTube from 'icons/src/YouTube';
import LinkedinIn from 'icons/src/LinkedinIn';
import Instragram from 'icons/src/Instragram';
import Twitter from 'icons/src/Twitter';
import FacebookF from 'icons/src/FacebookF';
import Container from 'gatsby-theme-core/src/components/container';

const Footer = ({ className }) => {
  const {
    facebook,
    youtube,
    linkedin,
    instagram,
    twitter,
  } = useSocialmedia();
  const { name } = useCompany();
  return (
    <footer className={className}>
      <Container>
        <InnerInfo>
          <div>
            &copy; {new Date().getFullYear()} {name}, powered by
            {' '}
            <AutomotivatedLink href="https://www.automotivated.nl">
              Automotivated
            </AutomotivatedLink>
          </div>
          <div>
            {facebook && (
              <SocialMediaLink href={facebook}>
                <FacebookF />
              </SocialMediaLink>
            )}
            {twitter && (
              <SocialMediaLink href={twitter}>
                <Twitter />
              </SocialMediaLink>
            )}
            {instagram && (
              <SocialMediaLink href={instagram}>
                <Instragram />
              </SocialMediaLink>
            )}
            {linkedin && (
              <SocialMediaLink href={linkedin}>
                <LinkedinIn />
              </SocialMediaLink>
            )}
            {youtube && (
              <SocialMediaLink href={youtube}>
                <YouTube />
              </SocialMediaLink>
            )}
          </div>
        </InnerInfo>
      </Container>
    </footer>
  );
};

const AutomotivatedLink = styled(OutboundLink)`
  color: inherit;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const SocialMediaLink = styled(OutboundLink)`
  display: inline-block;
  margin-left: 1rem;
  padding-top: .5rem;
  color: ${({ theme }) => theme.primaryColor};
  transition: .2s;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    padding-top: 0;
  }
  &:hover {
    color: white;
  }
  svg {
    height: 1rem;
  }
`;

const InnerInfo = styled.div`
  line-height: 1.4;
  text-align: center;
  display: grid;
  grid-gap: 1rem;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    text-align: left;
    display: flex;
    justify-content: space-between;
  }
`;

export default styled(Footer)`
  background-color: ${({ theme }) => theme.grayDarkColor};
  padding: 2rem;
  font-weight: lighter;
  font-size: .9rem;
  color: ${({ theme }) => theme.grayColor};

`;
